const ADMIN_ROLE = 'admin';

export const hasAdminRole = (roles: string[] | undefined): boolean => {
    return roles?.some((role) => role.trim().toLowerCase() === ADMIN_ROLE) ?? false;
};
